export default __webpack_public_path__ + "static/media/gallery - story - bard (1)_02.6743b663.jpg";